const CONSTANTS = {
    CAPTCHA_ENABLED: false,
    CAPTCHA_KEY: '6LfUWpkbAAAAACHW4UJ9uoyBomgRcH-UjJAn6M-E',
    SESSION_PERIOD: 15,
    WARNING_COUNTDOWN: 60,
};

export default CONSTANTS;

// SESSION_PERIOD is in minutes
// WARNING_COUNTDOWN is in seconds
